import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _, {camelCase, isEmpty} from 'lodash';
import {useDispatch} from "react-redux";

import {addToCart} from "../../ReduxStore/ShoppingCart/cartSlice";
import {getClassList} from "../../Utility/siteConfig";
import {isOutOfStock} from "../logic/products";

export default function DynamicAddButton({
  className,
  disabled,
  product,
  application,
  caption = "Add to Cart",
  quantity = 1
}) {
  const dispatch = useDispatch();

  const outOfStock = isOutOfStock(product);

  disabled ||= isEmpty(product);

  const handleClick = (evt) => {
    evt.preventDefault();

    if (outOfStock) {
      alert("Sorry, this product is out of stock.");
    } else if (disabled) {
      alert("Please select all options before adding to cart.");
    } else {
      dispatch(addToCart({product, application, quantity}));
    }
  }

  className = getClassList({
    key: (outOfStock || disabled) ? 'AddToCartButton.disabled' : 'AddToCartButton',
    base: 'text-lg px-4 py-3 uppercase font-bold',
    fallback: [(outOfStock || disabled) ? 'btn-disabled' : 'btn-primary'],
    append: className
  });

  // handleClick is wanted even if disabled
  return (
    <button type="button" className={className}
      onClick={handleClick}>
      {outOfStock ? "Out of Stock" : caption}
    </button>
  );
}

DynamicAddButton.propTypes = {
  product: PropTypes.object,
  application: PropTypes.object, // optional, for universal
  disabled: PropTypes.bool
};


